import cargillLogo from '../../assets/cargil-logo.png';
import * as S from './style';

export const Footer = () => {
    return <S.Footer >
        <img src={cargillLogo} alt="Logotipo da empresa Cargil" />
    </S.Footer>
}